import { useLayoutEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useRetroMode } from '../context/RetroModeContext'

gsap.registerPlugin(ScrollTrigger)

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

// Continuous scroll-scrubbed zoom (not a one-time reveal): the element is
// biggest when centered in the viewport (in "focus") and visibly smaller
// near the edges (entering/exiting, out of focus)  a cover-flow-style
// focus effect that keeps reacting the whole time it's scrolling through.
export const useScrollZoom = ({ peakScale = 1.08, minScale = 0.86 } = {}) => {
  const ref = useRef(null)
  const { retroMode } = useRetroMode()

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return undefined

    if (retroMode || prefersReducedMotion()) {
      gsap.set(el, { scale: 1, clearProps: 'transform' })
      return undefined
    }

    const trigger = ScrollTrigger.create({
      trigger: el,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 0.3,
      onUpdate: (self) => {
        const focus = 1 - Math.abs(self.progress * 2 - 1)
        gsap.set(el, { scale: minScale + focus * (peakScale - minScale) })
      },
    })

    return () => trigger.kill()
  }, [retroMode, peakScale, minScale])

  return ref
}
